import { DocumentId } from "@bitory-gmbh/bsm";
import { RFC3339timestamp } from "@bitory-gmbh/nidavellir";

/** Mirrors `document.OfferReferenceBase`, backend/core/document/domain/document/offer_reference_base.go. */
export type OfferReferenceBase = {
  offerId?: DocumentId;
  offerDate?: RFC3339timestamp;
  offerReference: string;
};

/** Mirrors `document.OfferReferenceBasePatch`, backend/core/document/domain/document/offer_reference_base.go. */
export type OfferReferenceBasePatch = {
  offerId?: DocumentId | null;
  offerDate?: RFC3339timestamp | null;
  offerReference?: string;
};

/**
 * patchOfferReferenceBase returns document with the fields set in patch
 * applied, e.g. for an optimistic cache update. A field set to null is
 * cleared.
 */
export function patchOfferReferenceBase<T extends OfferReferenceBase>(
  document: T,
  patch: OfferReferenceBasePatch,
): T {
  return {
    ...document,
    offerId:
      patch.offerId === undefined
        ? document.offerId
        : (patch.offerId ?? undefined),
    offerDate:
      patch.offerDate === undefined
        ? document.offerDate
        : (patch.offerDate ?? undefined),
    offerReference: patch.offerReference ?? document.offerReference,
  };
}
